import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGetPerformance, apiGetPerformanceCSV } from "../api";
import fileDownload from "js-file-download";
import { errorHandler } from "../utils/errorHandling";

const performanceInitialState = {
	performance: {},
	selectedOffers: [],
	loadingPerformance: false,
};

export const fetchPerformance = createAsyncThunk(
	"performance/fetchPerformance",
	async (params, { dispatch, rejectWithValue }) => {
		try {
			dispatch(setLoadingPerformance(true));
			const response = await apiGetPerformance(params);

			dispatch(setLoadingPerformance(false));
			return response.data;
		} catch (e) {
			errorHandler(e);
			return rejectWithValue(e);
		}
	},
);

export const fetchPerformanceCSV = createAsyncThunk(
	"performance/fetchPerformanceCSV",
	async ({ fileName, offerId, onLoadingEnd }, { rejectWithValue }) => {
		try {
			const response = await apiGetPerformanceCSV(offerId);
			if (response.data) {
				fileDownload(response.data, `${fileName}.csv`);
			}
		} catch (e) {
			errorHandler(e);
			return rejectWithValue(e);
		} finally {
			onLoadingEnd();
		}
	},
);

const performanceSlice = createSlice({
	name: "performance",
	initialState: performanceInitialState,
	reducers: {
		setLoadingPerformance: (state, { payload }) => {
			state.loadingPerformance = payload;
		},
		addSelectedOffer: (state, { payload }) => {
			state.selectedOffers.push(payload);
		},
		removeSelectedOffer: (state, { payload }) => {
			state.selectedOffers = state.selectedOffers.filter(
				(offer) => offer.id !== payload.id,
			);
		},
		resetSelectedOffers: (state) => {
			state.selectedOffers = [];
		},
		resetPerformanceData: (state) => {
			state.performance = {};
		},
		resetPerformance: (state) => {
			state.selectedOffers = [];
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPerformance.fulfilled, (state, { payload }) => {
				state.performance = payload;
			})
			.addCase(fetchPerformance.rejected, (state, action) => {
				// Handle the error state here, if needed
				console.error("Error fetching performance:");
			});
	},
});

export const performanceReducer = performanceSlice.reducer;
export const {
	setLoadingPerformance,
	addSelectedOffer,
	removeSelectedOffer,
	resetSelectedOffers,
	resetPerformanceData,
	resetPerformance,
} = performanceSlice.actions;
